
export default {
    namespaced: true,
    state() {
        return {
            activeLoader: false,
        }
    },
    getters: {
        activeLoader: state => {
            return state.activeLoader
        },
    },
    mutations: {
        activeLoader: function(state , payload) {
            state.activeLoader = payload
        },
    },
    actions: {
    }
};